import { FC, useMemo } from 'react';
import {
  ChartsYAxisProps,
  LineChart,
  LineSeriesType,
  axisClasses,
} from '@mui/x-charts';
import { format, startOfYear, sub } from 'date-fns';
import { ButtonGroupOptions } from '../PatientProgressionCard';

interface LineChartProps {
  chartData: any[];
  yAxes: ChartsYAxisProps[];
  series: LineSeriesType[];
  xAxisRangeType: ButtonGroupOptions;
  xAxisRange: {
    start: Date;
    end: Date;
  };
}

export const CustomLineChart: FC<LineChartProps> = ({
  chartData,
  series,
  yAxes,
  xAxisRangeType,
  xAxisRange,
}) => {
  const xAxisMinMax = useMemo(() => {
    let min = undefined;
    let max = undefined;

    if (xAxisRangeType === ButtonGroupOptions.THREE) {
      const now = new Date();
      min = sub(now, { months: 3 });
      max = now;
    }

    if (xAxisRangeType === ButtonGroupOptions.YTD) {
      const now = new Date();
      min = startOfYear(now);
      max = now;
    }

    if (xAxisRangeType === ButtonGroupOptions.ALL_TIME) {
      const now = new Date();
      max = now;
    }

    if (xAxisRangeType === ButtonGroupOptions.CUSTOM) {
      min = xAxisRange.start;
      max = xAxisRange.end;
    }

    return {
      min,
      max,
    };
  }, [xAxisRangeType, xAxisRange]);

  return (
    <LineChart
      skipAnimation
      slotProps={{
        legend: {
          labelStyle: {
            fontSize: 12,
            fontWeight: 400,
          },
        },
      }}
      xAxis={[
        {
          label: 'Date',
          dataKey: 'created_at',
          scaleType: 'time',
          min: xAxisMinMax.min,
          max: xAxisMinMax.max,
          tickMinStep: 1000 * 60 * 60 * 24,
          valueFormatter: (value, context) => {
            if (context.location === 'tooltip') {
              return value ? format(value, 'yyyy-MM-dd HH:mm aa') : '';
            }

            return value ? format(value, 'yyyy-MM-dd') : '';
          },
        },
      ]}
      leftAxis='leftAxis'
      rightAxis={yAxes.length > 1 ? 'rightAxis' : undefined}
      yAxis={yAxes}
      series={series}
      dataset={chartData}
      margin={{ left: 55, right: 55 }}
      sx={{
        [`.${axisClasses.left} .${axisClasses.label}`]: {
          transform: 'translate(-15px, 0)',
        },
        [`.${axisClasses.right} .${axisClasses.label}`]: {
          transform: 'translate(15px, 0)',
        },
      }}
    />
  );
};
